module.exports = __webpack_public_path__ + "img/stern.ff76231d.png";